import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * Los gastos fijos programados, dentro del grupo `_direccion`.
 *
 * `app.programar_gasto_recurrente` exige `administrador` a secas, y los tres escenarios de la
 * feature 18 empiezan con «el administrador». Los dos reportes de la proyeccion admiten ademas al
 * contador, y eso no le da pantalla: que un rol pueda llamar una funcion no es que el escenario
 * hable de el. Mismo criterio que el acumulado de cortesias con el jefe de operarios.
 */
export const rutaGastosFijos = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/gastos-fijos',
  component: lazyRouteComponent(() => import('./gastos-fijos-pantalla.js'), 'RutaGastosFijos'),
});
